require('./searchBeneficiaries.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const classnames = require('classnames');
const PureRenderMixin = require('react-addons-pure-render-mixin');
// @ commons
const { formatText } = require('core/i18n').i18n;
// @ components
const ContactItemSelected = require('components/searchBeneficiaries/contactItemSelected');
const ContactItemOptions = require('components/searchBeneficiaries/contactItemOptions');

class SearchBeneficiaries extends React.Component {

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentDidMount() {
        const { selectedValue, initialValue } = this.props;
        if (initialValue && !selectedValue) {
            // set initial beneficiary from URL if there is no beneficiary selected.
            this.props.onSelect(initialValue);
        }
    }

    buildOptions() {
        const { immBeneficiaries } = this.props;
        return immBeneficiaries.get('byOrder').toJS().map((contactId) => {
            const contact = immBeneficiaries.getIn(['byId', contactId]).toJS();
            return {
                id: this.props.id,
                value: contact.id,
                fullName: contact.name,
                alias: contact.alias,
                iban: contact.iban,
                currency: contact.currency
            }
        });
    }

    handleChange(item) {
        if (!item){
            return;
        }
        this.props.onSelect(item.value);
    }

    searchMethod(options, filterString) {
        const results = options.filter( option => {
            const exp = new RegExp(filterString, 'i');
            const joined = option.fullName + ' ' + option.alias + ' ' + option.iban;
            return !!joined.match(exp);
        });

        return results;
    }

    render () {
        const { error, errorMsg, selectedValue, label} = this.props;
        const options = this.buildOptions();
        const clearable = false;
        const placeholder= formatText('transfers-transfers_existingBeneficiaryPlaceHolder');
        const noResultsText = formatText('transfers-noResults');

        return (
            <div>
                <OKSelect
                    name="form-field-name"
                    label={label}
                    className={classnames('search-contacts', {'search-contacts--error' : error})}
                    placeholder={placeholder}
                    onChange={this.handleChange}
                    onBlur={this.handleBlur}
                    onOpen={this.handleFocus}
                    optionComponent={ContactItemOptions}
                    options={options}
                    value={selectedValue}
                    valueComponent={ContactItemSelected}
                    clearable={clearable}
                    filterOptions={this.searchMethod}
                    noResultsText={noResultsText}
                />
                <div className="search-contacts__error-msg">
                    {errorMsg}
                </div>
            </div>
        );
    }
}

SearchBeneficiaries.propTypes = {
    id: PropTypes.string,
    onSelect: PropTypes.func,
    selectedValue: PropTypes.string,
    initialValue: PropTypes.string,
    immBeneficiaries: PropTypes.object,
    error: PropTypes.bool,
    errorMsg: PropTypes.string,
    label: PropTypes.string
};

SearchBeneficiaries.defaultValues = {
    errorMsg: '',
    label: ''
}

module.exports = SearchBeneficiaries;
